import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { ContractorInfo } from '../../models/ContractorInfo';
import { TravelerInfo } from '../../models/TravelerInfo';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { BasicInfo } from '../../models/BasicInfo';
import { SpecialProvision } from '../../models/SpecialProvision';
import { OthersInfo } from '../../models/OthersInfo';
import { ConfirmMode } from './mode/ConfirmMode';
import { ConfirmItemMode } from './mode/ConfirmItemMode';
import { PlanInfo } from '../../models/PlanInfo';
import { ScrollPositionInfo } from '../../models/ScrollPositionInfo';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { CollateralInfo } from '../../models/CollateralInfo';
import { CheckBlackListRequest } from '../../service/service-models/check-black-list/CheckBlackListRequest';
import { BlackListInfo } from '../../service/models/black-list/black-list-info';
import { BlackListService } from '../../service/BlackListService';

export let selectCompensationIdx: string = null;		// 担保インデックス
export let deathCompensationExists: boolean = false;	// 死亡補償フラグ

/**
 * 個人情報登録ビュー情報
 */
export class ConfirmComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// モデル ----------------------------------------------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode				: string 				= null;	// 保険商品コード
	@WprDI_ScopeModel('BasicInfo')
	@WprModel('BasicInfo')
	private m_BasicInfo					: BasicInfo 			= null; // 基本情報
	@WprDI_ScopeModel('PlanInfo')
	@WprModel('PlanInfo')
	private m_PlanInfo					: PlanInfo 				= null; // プラン情報
	@WprDI_ScopeModel('SpecialProvision')
	@WprModel('SpecialProvision')
	private m_SpecialProvision			: SpecialProvision 		= null; // 特約・約款情報
	@WprDI_ScopeModel('ContractorInfo')
	@WprModel('ContractorInfo')
	private m_ContractorInfo			: ContractorInfo 		= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('TravelerInfo')
	@WprListData('TravelerInfo')
	@WprModel('TravelerInfo')
	private m_TravelerListInfo			: TravelerInfo[] 		= null; // 旅行者（被保険者）リスト情報
	@WprDI_ScopeModel('ContractNoticeInfo')
	@WprListData('ContractNoticeInfo')
	@WprModel('ContractNoticeInfo')
	private m_ContractNoticeList		: ContractNoticeInfo[] 	= null; // 告知事項情報
	@WprDI_ScopeModel('OthersInfo')
	@WprModel('OthersInfo')
	private m_OthersInfo				: OthersInfo 			= null; // その他情報
	@WprModel('Explanation')
	private m_Explanation				: string 				= null;	// プラン説明
	@WprDI_ScopeModel('ScrollPositionInfo')
	@WprModel('ScrollPositionInfo')
	private m_ScrollPositionInfo		: ScrollPositionInfo 	= null; // スクロール位置情報
	@WprDI_ScopeModel('CollateralInfo')
	@WprListData('CollateralInfo')
	@WprModel('CollateralInfo')
	private m_Collaterals				: CollateralInfo[] 		= null;	// 補償表示情報
	// -----------------------------------------------------------------------------------------------------------------

	// DI情報  ---------------------------------------------------------------------------------------------------------
	@WprDI_Control
	private m_Check						: WprControlInfo 		= null; // チェックボタン情報
	// -----------------------------------------------------------------------------------------------------------------

	// サブビュー/モード  ------------------------------------------------------------------------------------------------
	@WprViewMode
	private m_ViewCheckMode 			= new ConfirmMode(); 		// チェック状態管理モード
	@WprViewMode
	private m_ViewItemMode 				= new ConfirmItemMode(); 	// 保険項目切り替えモード
	// -----------------------------------------------------------------------------------------------------------------

	// コンストラクタ  --------------------------------------------------------------------------------------------------
	public constructor() {
		super('step6_confirm');
	}
	// -----------------------------------------------------------------------------------------------------------------

	// サービス  -------------------------------------------------------------------------------------------------------
	// WRQ-2990_旅行保険　直扱販売のための対応 START
	private m_BlackListService: BlackListService = new BlackListService();	// ブラックリスト入り判定サービス
	// WRQ-2990_旅行保険　直扱販売のための対応 END
	// -----------------------------------------------------------------------------------------------------------------

	// override メソッド  -----------------------------------------------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		// 基本情報
		this.addConfig('explanation', 'プラン説明', 'Explanation', { bindModel: true });
		this.addConfig('insuranceType', '保険種類', 'BasicInfo');
		this.addConfig('plan', '契約プラン', 'BasicInfo');
		this.addConfig('insuranceFee', '合計保険料（全員分）', 'BasicInfo');
		this.addConfig('insurancePeriod', '保険期間', 'BasicInfo');
		this.addConfig('applicationDate', '申込日', 'BasicInfo');
		// 補償内容
		this.addListConfig('collateralName', '画面上補償名', 'CollateralInfo', { bindName: 'collateralName' });
		this.addListConfig('collateralAmount', '補償金額', 'CollateralInfo', { bindName: 'collateralAmount' });
		this.addListConfig('displayCollateralName', 'モーダル内補償名', 'CollateralInfo', { bindName: 'displayCollateralName' });
		this.addListConfig('collateralDescription', 'モーダル内補償説明', 'CollateralInfo', { bindName: 'collateralDescription' });
		// 告知事項
		this.addListConfig('noticeMessage', '告知事項メッセージ', 'ContractNoticeInfo');
		// 特約・約款
		this.addConfig('specialProvision', '特約・約款', 'SpecialProvision');
		// 契約者（申込者）
		this.addConfig('lastNameContractor', '姓（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'lastName' });
		this.addConfig('firstNameContractor', '名（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'firstName' });
		this.addConfig('romanLastNameContractor', '姓（ローマ字）', 'ContractorInfo', { bindName: 'romanLastName' });
		this.addConfig('romanFirstNameContractor', '名（ローマ字）', 'ContractorInfo', { bindName: 'romanFirstName' });
		this.addConfig('yearContractor', '年', 'ContractorInfo', { bindName: 'year' });
		this.addConfig('monthContractor', '月', 'ContractorInfo', { bindName: 'month' });
		this.addConfig('dateContractor', '日', 'ContractorInfo', { bindName: 'date' });
		this.addConfig('genderContractor', '性別', 'ContractorInfo', { bindName: 'gender' });
		this.addConfig('postalCode', '郵便番号', 'ContractorInfo');
		this.addConfig('prefecture', '都道府県', 'ContractorInfo');
		this.addConfig('address1', '住所1', 'ContractorInfo');
		this.addConfig('address2', '住所2', 'ContractorInfo');
		this.addConfig('tel', '電話番号', 'ContractorInfo');
		this.addConfig('mailAddress', 'メールアドレス', 'ContractorInfo');
		// 旅行者（被保険者）
		this.addListConfig('romanLastNameTraveler', '姓（ローマ字）', 'TravelerInfo', { bindName: 'romanLastName' });
		this.addListConfig('romanFirstNameTraveler', '名（ローマ字）', 'TravelerInfo', { bindName: 'romanFirstName' });
		this.addListConfig('yearTraveler', '年', 'TravelerInfo', { bindName: 'year' });
		this.addListConfig('monthTraveler', '月', 'TravelerInfo', { bindName: 'month' });
		this.addListConfig('dateTraveler', '日', 'TravelerInfo', { bindName: 'date' });
		this.addListConfig('genderTraveler', '性別', 'TravelerInfo', { bindName: 'gender' });
		// その他
		this.addConfig('agency', '取扱代理店', 'OthersInfo');
		this.addConfig('check', '確認チェックボックス', null);
		this.addConfig('toNext', '支払い画面', null);
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		super.onRegisterAction();
		this.addListAction('question', 'CollateralInfo', this.onHelpShow);
		this.addAction('close', this.onClose);
		this.addAction('edit', this.onEdit);
		this.addListAction('listEdit', 'TravelerInfo', this.onListEdit);
		this.addAction('pdf', this.onDownLoad);
		this.addAction('toNext', this.onNext);
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (!this.m_TravelerListInfo || !this.m_ContractNoticeList || !this.m_Collaterals) {
			this.onViewError();
		}
		else {
			this.setListData('TravelerInfo', this.m_TravelerListInfo);
			this.setListData('ContractNoticeInfo', this.m_ContractNoticeList);
			this.setListData('CollateralInfo', this.m_Collaterals);
			this.setJPUnit();
			deathCompensationExists = this.deathCompensationExists(this.m_Collaterals);
			if (this.prevViewName === 'step7_payment') {
				this.m_Check.value = true;
				window.setTimeout(this.checkAgree.bind(this),10);
			}
			this.onUtagView();
			this.refreshView();
		}
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 情報を修正する（個人情報登録画面へ戻る）契約者用
	 */
	public onEdit(param: any): void {
		this.m_ScrollPositionInfo.id = 'contractor';
		this.pushPath('/step5_personal-information');
	}

	/**
	 * 情報を修正する（個人情報登録画面へ戻る）被保険者用
	 */
	public onListEdit(param: any, item: any): void {
		this.m_ScrollPositionInfo.id = 'traveler' + this.m_TravelerListInfo.indexOf(item);
		this.pushPath('/step5_personal-information');
	}

	/**
 	 * ヘルプ表示処理
 	 */
	public onHelpShow(param: any, item: any): void {
		this.setViewMode('helpMode', item.collateralKey);
		const idx: number = this.m_Collaterals.indexOf(item);
		selectCompensationIdx = `${idx}`;
		// this.refreshModel();
	}

	/**
	 * ヘルプ閉じる処理
	 */
	public onClose(param: any): void {
		this.setViewMode('helpMode', '');
		selectCompensationIdx = null;
		// this.refreshModel();
	}

	/**
	* PDFダウンロード処理
	*/
	public onDownLoad(param: any): void {
		window.open(this.m_OthersInfo.url,'url');
		// this.refreshModel();
	}

	/**
     * 支払画面遷移処理
     */
	public onNext(param: any): void {
		this.refreshModel();
		this.refreshView();
		// WRQ-2990_旅行保険　直扱販売のための対応 START
		const req = new CheckBlackListRequest();
		req.blackListInfo = new BlackListInfo();
		req.blackListInfo.surnameHan = this.m_ContractorInfo.romanLastName;
		req.blackListInfo.firstnameHan = this.m_ContractorInfo.romanFirstName;
		req.blackListInfo.dateOfBirthYyyy = this.m_ContractorInfo.year;
		req.blackListInfo.dateOfBirthMm = this.m_ContractorInfo.month;
		req.blackListInfo.dateOfBirthDd = this.m_ContractorInfo.date;
		req.blackListInfo.phoneNumber = this.m_ContractorInfo.tel;
		
		this.m_BlackListService.checkBlackList(this, req, (result) => {
			if(result.blackListFlag === true)
				this.pushPath('/b_error');
			else
				this.pushPath('/step7_payment');
		});
		// WRQ-2990_旅行保険　直扱販売のための対応 END
	}
	// --------------------------------------------------------------------------
	
	// privateメソッド -----------------------------------------------------------
	/**
	 * 死亡補償が含まれているか判定
	 * @param collaterals
	 * @returns 死亡補償が存在する場合true、ない場合false
	 */
	private deathCompensationExists(collaterals: CollateralInfo[]): boolean{
		for (let i = 0; i < collaterals.length; i++) {
			if (collaterals[i].collateralKey === 'AT04') {
				return true;
			}
			else if (collaterals[i].collateralKey === 'AT21') {
				return true;
			}
			else if (collaterals[i].collateralKey === 'AT30') {
				return true;
			}
		}
		return false;
	}

	/**
	 * 数値 -> 日本円単位設定処理
	 */
	private setJPUnit(): void {
		let collSize = this.m_Collaterals.length;
		for(let j=0; j<collSize; j++) {
			let cInfo = this.m_Collaterals[j];
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
			// if(!cInfo.collateralAmount.match('円'))
			if(!cInfo.collateralAmount.match('円') && cInfo.collateralAmount.includes('無制限') !== true) {
			// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
				cInfo.collateralAmount = this.toJPUnit(cInfo.collateralAmount);
			}
		}
	}

	/**
	 * 同意チェック処理
	 */
	private checkAgree() {
		let element = <HTMLInputElement>document.getElementById('lb_yes');
		element.checked = true;
	}
	// ---------------------------------------------------------------------------
}
